import render from 'utils/react';

import MainSite from './components/MainSite';

render(MainSite);
